module.exports = __webpack_public_path__ + "static/media/good-active.68795aca.svg";